/** @file Observable store tracking the currently-loaded play (or new/unsaved). */
import { createStore } from "./state.js";

/** @typedef {{ playId: string, name: string, teamId: string | null } | null} CurrentPlay */
/** @typedef {{ current: CurrentPlay }} CurrentPlayState */

/** @type {import("./state.js").Store<CurrentPlayState>} */
export const currentPlayStore = createStore(
  /** @type {CurrentPlayState} */ ({ current: null }),
);

export function startNewPlay() {
  currentPlayStore.set(/** @type {CurrentPlayState} */ ({ current: null }));
}

/**
 * @param {NonNullable<CurrentPlay>} meta
 */
export function setCurrentPlay(meta) {
  currentPlayStore.set({ current: meta });
}
